import React from 'react';
import { Box, TextField, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';

interface YieldFieldProps {
  amount: number;
  isPercent: boolean;
  onChange: (patch: Partial<{ yieldValue: number; yieldIsPercent: boolean }>) => void;
}

export function YieldField({ amount, isPercent, onChange }: YieldFieldProps) {
  return (
    <Box data-testid="yield-field" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Typography variant="subtitle2" sx={{ fontWeight: 600, minWidth: 40 }}>Yield</Typography>
      <TextField
        type="number"
        size="small"
        sx={{ width: 100 }}
        value={amount}
        onChange={(e) => onChange({ yieldValue: Math.max(0, +e.target.value) })}
        slotProps={{ htmlInput: { min: 0 } }}
      />
      <ToggleButtonGroup
        size="small"
        exclusive
        value={isPercent ? '%' : '#'}
        onChange={(_, v) => { if (v) onChange({ yieldIsPercent: v === '%' }); }}
      >
        <ToggleButton value="%" sx={{ px: 1.5 }}>%</ToggleButton>
        <ToggleButton value="#" sx={{ px: 1.5 }}>#</ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
}
